// extracted by mini-css-extract-plugin
module.exports = {"container":"ug","copy":"vg","field":"wg","error":"xg","disabled":"yg","termsContainer":"zg","termsHeading":"Ag","termsCopy":"Bg","submit":"Cg","srOnly":"Dg"};